import reducers from './reducers';
import sagas from './sagas';

const notificationsModule = {
  sagas,
  reducers: { notifications: reducers }
};

export default notificationsModule;
